export const generalKeysToIgnore = [
  "feeStructure",
  "currentBalance",
  "availableBalance",
  "productId",
  "productType",
  "individuals",
  "investmentProfile",
  "kycProfile",
  "registeredAddress",
  "physicalAddress",
  "mailingAddress",
  "createdAt",
  "lang",
  "telephoneNumber",
  "websiteAddress",
  "stateOfIncorporation",
  "countryOfIncorporation",
  "corporateEntityType",
  "emailAddress",
  "establishedOn",
  "naics",
  "naicsDescription",
  "signedAgreementId",
  "registeredNumber",
  "corporateTaxReferenceNumber",
  "applicationType",
  "status",
  "termsAndConditionsAccepted",
];

export const internalTransferKeysToIgnore = [
  "id",
  "destinationAssetTypeId",
  "sourceAssetTypeId",
  "transactionDate",
  "amountToCredit",
  "amountToDebit",
  "categoryId",
  "sourceTradingName",
  "destinationTradingName",
  "sourceAccountIdId",
  "destinationAccountId",
  "destinationAccountIdId",
];
